// extracted by mini-css-extract-plugin
module.exports = {"title":"styles__title___-0jb_","header":"styles__header___22BIQ"};